export enum SettingsEnum {
  ENABLED_LANGUAGES = 'enabled_languages',
  DEFAULT_LANGUAGE = 'default_language',
  DEFAULT_CURRENCY = 'default_currency',
  TENANTS_AVAILABLE = 'tenants_available',
  DYNAMIC_ACCOUNT_STATUS_PROP = 'dynamic_account_status_property',
  ADMIN_ACCOUNT_STATUSES = 'admin_account_statuses',
  ASSETS_ROUTE = 'assets_route',
  FIREBASE_CONFIG = 'firebase_config',
  // FEATURE FLAGS
  CASINO_ENABLE = 'casino_enable',
  CRM_ENABLE = 'crm_enable',
  GAMIFICATION_ENABLE = 'gamification_enable',
  MISSIONS_ENABLE = 'missions_enable',
  MULTICURRENCY_ENABLE = 'multicurrency_enable',
  SPORTS_ENABLE = 'sports_enable',
  MULTITENANT_ENABLE = 'multi_tenant_enabled',
  BIGQUERY_ENABLE = 'bigquery_enable',
  CASINO_PICKUP_ENABLE = 'casino_pickup_enable',
  TOURNAMENTS_ENABLE = 'tournaments_enable',
  BOOSTERS_ENABLE = 'boosters_enable',
  BONUS_API_ENABLE = 'operator_bonus_list_enable',
  REWARD_CLAIM_ENABLE = 'is_reward_activated_by_player',
  PRIZESHARK_ENABLE = 'prizeshark_integration_enable',
  // CRM
  FROM = 'email_from',
  REPLY_TO = 'email_reply_to',
  API_KEY = 'email_api_key',
  MONTHLY_MAX_EMAIL_THRESHOLD = 'monthly_max_email_threshold',
  MONTHLY_MAX_SMS_THRESHOLD = 'monthly_max_sms_threshold',
  BLOCK_DELIVERIES_ON_MAX = 'block_deliveries_on_max',
  CRM_BILLING_ALERTS_NOTIFICATION_EMAILS = 'crm_billing_alerts_notification_emails',
  COUNTRY_CODES_ALLOWED_SMS = 'country_codes_allowed_sms',
  EXCLUDE_PLAYERS_COOL_OFF_CATEGORY = 'exclude_players_cool_off_category',
  // GAMIFICATION
  EVENT_TYPE_CONTRIBUTION = 'event_type_contribution',
  PLAYER_AUTO_OPTIN_ENABLED = 'player_auto_optin_enabled',
  COUNTER_RESET_OPTIN_BEHAVIOR = 'counter_reset_optin_behavior',
  OPT_OUT_REASONS = 'opt_out_reasons',
  TOKEN_SETTINGS = 'contribution-tokens-setting',
  PAYMENT_METHODS = 'payment_methods',
  ONSITE_NOTIFICATIONS_LIMIT = 'messaging_service_on_site_max_concurrent',
  MISSIONS_BET_TYPE_CONTRIBUTION = 'missions_bet_type_contribution',
  // RANKS DOWNGRADE
  ACTIVITY_PERIOD = 'activity_period',
  DOWNGRADE_COMPARISON_BASE = 'downgrade_comparison_base',
  DOWNGRADE_ENABLE = 'downgrade_enable',
  DOWNGRADE_METHOD = 'downgrade_method',
  DOWNGRADE_RULE = 'downgrade_rule',
  MIN_ACTIVITY = 'min_activity',
  TOKEN_LOSS_ON_DOWNGRADE = 'token_loss_on_downgrade',
  // ENABLE CRM INTEGRATION
  ENABLE_GAMANZA = 'crm_option_enable_gamanza',
  ENABLE_OPTIMOVE = 'crm_option_enable_optimove',
  OPTIMOVE_API_URL = 'optimove_api_url',
  OPTIMOVE_TENANT_ID = 'optimove_tenant_id',
  OPTIMOVE_TRIGGER_TOKEN = 'optimove_server_events_trigger_token',
  OPTIMOVE_MAX_RETRY_OPTS = 'optimove_server_events_max_retry_opts',
  // PRIZESHARK
  PRIZESHARK_CONFIGURATION = 'prizeshark_configuration',
  // TEMPLATE DATA
  TEMPLATE_DATA_ONSITE = 'template_data_onsite',
  TEMPLATE_DATA_EMAIL = 'template_data_email',
}
